var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartAlt12W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.475C4.49167 10.35 3.65625 9.91042 2.99375 9.15625C2.33125 8.40208 2 7.51667 2 6.5C2 5.95 2.10833 5.42292 2.325 4.91875C2.54167 4.41458 2.85 3.975 3.25 3.6L3.9625 4.3125C3.64583 4.59583 3.40625 4.925 3.24375 5.3C3.08125 5.675 3 6.075 3 6.5C3 7.23333 3.23333 7.88125 3.7 8.44375C4.16667 9.00625 4.76667 9.35 5.5 9.475V10.475ZM6.5 10.475V9.475C7.225 9.34167 7.82292 8.99583 8.29375 8.4375C8.76458 7.87917 9 7.23333 9 6.5C9 5.66667 8.70833 4.95833 8.125 4.375C7.54167 3.79167 6.83333 3.5 6 3.5H5.9625L6.5125 4.05L5.8125 4.75L4.0625 3L5.8125 1.25L6.5125 1.95L5.9625 2.5H6C7.11667 2.5 8.0625 2.8875 8.8375 3.6625C9.6125 4.4375 10 5.38333 10 6.5C10 7.50833 9.66875 8.38958 9.00625 9.14375C8.34375 9.89792 7.50833 10.3417 6.5 10.475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartAlt12W);
export default __webpack_public_path__ + "static/media/restart_alt_12w.304b96f9d1d390453f5e993388339bd5.svg";
export { ForwardRef as ReactComponent };